export const MESSAGE_CHAR_LIMIT = 1000;
